import { RobotAvatar } from '@/components/agent/RobotAvatar'
import './redteam-task-icon.css'

/** IDs also identify red-team tasks in inspectors without catalog metadata. */
export function RedTeamTaskIcon({ task }: { task: { task_id: string } }) {
  if (!task.task_id.toLowerCase().includes('redteam')) return null
  return <span className="redteam-task-icon" role="img" aria-label="Red-team task" title="Red-team task">
    <RobotAvatar identity={task.task_id} variant="redteam" size={24} />
  </span>
}
